<template>
  <div id="app">
    <vue-page-stack>
      <router-view :key="$route.fullPath" class="router-view-c"></router-view>
    </vue-page-stack>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      meta: [{ charset: 'utf-8' }]
    },
    name: 'App',
    data() {
      return {};
    }
  };
</script>

<style>
  @import './style/common.css';
  @import './iconfont/iconfont.css';

  /* iOS禁止微信调整字体大小 */
  body {
    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue